angular.module('dpw.directives').directive('trackedByMixpanel', ['mixpanelService', function (mixpanelService) {
    return {
        restrict: 'A',
        scope: {
            mixpanelEvent: '<',
            mixpanelProperties: '<'
        },
        bindToController: true,
        controllerAs: 'ctrl',
        controller: [function () {}],
        link: function (scope, element, attrs, ctrl) {
            if (shouldTrack()) {
                element.on('click', function () {
                    mixpanelService.track(ctrl.mixpanelEvent, ctrl.mixpanelProperties);
                });
            }

            function shouldTrack() {
                return validEventName(ctrl.mixpanelEvent) && validProperties(ctrl.mixpanelProperties);
            }

            function validEventName(eventName) {
                return _.isString(eventName);
            }

            function validProperties(properties) {
                return _.isObject(properties);
            }
        }
    };
}]);
